<select id="language" (change)="changeLanguage($event)">
  @for (lang of languages; track lang.code) {
    <option [selected]="currentLocale === lang.code" [value]="lang.code">
      {{ lang.label }}
    </option>
  }
</select>
